const LANGGRAPH_INTEGRATION_NAME = "LangGraph";
const LANGGRAPH_ORIGIN = "auto.ai.langgraph";

export { LANGGRAPH_INTEGRATION_NAME, LANGGRAPH_ORIGIN };
//# sourceMappingURL=constants.js.map
